module.exports = __webpack_public_path__ + "static/1-92059aac8f64232b1a701ff32b5d91f4.png";